import { csvExportDateFormat } from '../../agent-production/helpers/dataFormatters';
import { exportFilenameTemplates} from '../constants';
import { marketShareListingStatuses as listingStatuses } from '../../constants';
import { generateFileName } from '../../common/helpers/export';
import { fieldMarkers } from '../../common/constants/export';
import { exportTypes as agentDetailExportTypes } from '../../agent-production/components/helpers/agentProfile';

export const listingViewIds = {
    totalVolume: {
        exportLabel: listingStatuses.SoldBothSides
    },
    totalUnits: {
        exportLabel: listingStatuses.SoldBothSides
    },
    listVolume: {
        exportLabel: listingStatuses.SoldListSide
    },
    listUnits: {
        exportLabel: listingStatuses.SoldListSide
    },
    sellVolume: {
        exportLabel: listingStatuses.SoldSellSide
    },
    sellUnits: {
        exportLabel: listingStatuses.SoldSellSide
    },
    soldVolume: {
        exportLabel: listingStatuses.SoldSellSide
    },
    soldUnits: {
        exportLabel: listingStatuses.SoldSellSide
    },
    actVolume: {
        exportLabel: listingStatuses.ForSale
    },
    actUnits: {
        exportLabel: listingStatuses.ForSale
    },
    ucVolume: {
        exportLabel: listingStatuses.UnderContract
    },
    ucUnits: {
        exportLabel: listingStatuses.UnderContract
    },
    newListVolume: {
        exportLabel: listingStatuses.New
    },
    newListUnits: {
        exportLabel: listingStatuses.New
    },
};

export const getMarketShareFileName = (searchType, listingStatus, listingType) => {
    const date = csvExportDateFormat(new Date());

    const template = listingType
        ? exportFilenameTemplates.totals
        : exportFilenameTemplates.coverage;

    return generateFileName(template, {
        [fieldMarkers.SEARCH_TYPE]: searchType,
        [fieldMarkers.LISTING_STATUS_FILTER]: listingStatus,
        ...(listingType && { [fieldMarkers.LISTING_TYPE]: listingType }),
        [fieldMarkers.DATE]: date,
    });
};

export const getOfficeBreakdownFilename = ({ tableName, listingViewId, listingStatusTitle }) => {
    const listingType = listingViewId
        ? listingViewIds[listingViewId]?.exportLabel
        : listingStatusTitle;

    return generateFileName(exportFilenameTemplates.officeBreakdown, {
        [fieldMarkers.OWNER]: tableName,
        [fieldMarkers.LISTING_TYPE]: listingType,
    });
};

export const getListingBreakdownFilename = (tableName, listingType) => generateFileName(
    exportFilenameTemplates.listingBreakdown,
    {
        [fieldMarkers.OWNER]: tableName,
        [fieldMarkers.LISTING_TYPE]: listingType,
    }
);

export const getAgentDetailFileName = (agentName, selectedTabName, mlsName, period) => generateFileName(
    exportFilenameTemplates.agentDetails,
    {
        [fieldMarkers.AGENT_NAME]: agentName,
        [fieldMarkers.TAB_LABEL]: selectedTabName,
        [fieldMarkers.MLS_NAME]: mlsName,
        [fieldMarkers.PERIOD]: period,
    }
);

export const exportTypes = Object.freeze({
    msSearchResults: 'msSearchResults',
    msOfficesBreakdown: 'msOfficesBreakdown',
    msListingsBreakdown: 'msListingsBreakdown',
});

export const getFilename = exportDetails => ({
        [exportTypes.msSearchResults]:
            getMarketShareFileName(exportDetails.searchType, exportDetails.listingStatus, exportDetails.listingType),
        [exportTypes.msOfficesBreakdown]:
            getOfficeBreakdownFilename(exportDetails),
        [exportTypes.msListingsBreakdown]:
            getListingBreakdownFilename(exportDetails.tableName, exportDetails.listingBreakdownStatus),
        [agentDetailExportTypes.agentDetailSearchResults]:
            getAgentDetailFileName(exportDetails.agentName, exportDetails.selectedTabName, exportDetails.mlsName, exportDetails.period)
});
